// extracted by mini-css-extract-plugin
export default {"subscribeBtnContainer":"AvailableWithPlatformAccessButton_subscribeBtnContainer__M9rsd"};